This program has been developed by students from the bachelor Computer Science
at Utrecht University within the Software Project course. Copyright (c) Utrecht
University (Department of Information and Computing Sciences)

<template>
  <div class="wikiPage">
    <div class="pageContainer lg:grid-cols-2 md:grid-cols-1">
      <section>
        <CodeQuestWiki />
      </section>
      <section>
        <GuiWiki />
      </section>
    </div>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import CodeQuestWiki from "@/components/wikipages/CodeQuestWiki.vue";
import QuestionButton from "@/components/QuestionButton.vue";
import GuiWiki from "@/components/wikipages/GuiWiki.vue";

@Options({
  mounted() {
    //Scroll the opened wikipage into the view of the user
    var wikiItem = new URLSearchParams(window.location.search).get(
      "item"
    ) as string;
    let elem = document.getElementById(wikiItem);
    if (elem == null) return;
    elem.scrollIntoView({ behavior: "smooth", block: "start" });
  },
  components: {
    CodeQuestWiki,
    GuiWiki,
    QuestionButton,
  },
})
export default class Wiki extends Vue {}
</script>

<style lang="scss">
@import "src/assets/stylesheets/pages/Wiki.scss";
</style>
